export default "__VITE_ASSET__18daa266__"